// extracted by mini-css-extract-plugin
module.exports = {"label":"_02712f2b3b--label--klecL","label--new-data":"_02712f2b3b--label--new-data--c3ejH","input":"_02712f2b3b--input--RAbDx","icon":"_02712f2b3b--icon--iF5df"};